import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Innovation from './pages/Innovation';
import Documentation from './pages/Documentation';
import Security from './pages/Security';
import Terms from './pages/Terms';
import ConversationalBI from './pages/ConversationalBI';
import CompanyDataCloud from './pages/CompanyDataCloud';
import PushdownSQLEngine from './pages/PushdownSQLEngine';
import FAQ from './pages/FAQ';
import SignIn from './pages/SignIn';
import NotFound from './pages/NotFound';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  React.useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    // The target may not be mounted yet when arriving from another route
    // (e.g. "Schedule Platform Demo" -> /#request-briefing), so retry briefly.
    const id = decodeURIComponent(hash.slice(1));
    let tries = 0;
    const timer = setInterval(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView();
        clearInterval(timer);
      } else if (++tries > 20) {
        clearInterval(timer);
      }
    }, 50);
    return () => clearInterval(timer);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="bg-limestone font-sans text-wall antialiased">
        <ScrollToTop />
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[100] focus:bg-wall focus:px-4 focus:py-3 focus:text-[15px] focus:font-semibold focus:text-limestone"
        >
          Skip to content
        </a>
        <Header />
        <div id="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/innovation" element={<Innovation />} />
            <Route path="/documentation" element={<Documentation />} />
            <Route path="/security" element={<Security />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/conversational-bi" element={<ConversationalBI />} />
            <Route path="/company-data-cloud" element={<CompanyDataCloud />} />
            <Route path="/pushdown-sql-engine" element={<PushdownSQLEngine />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
